exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-a3b8f536&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ButtonCollection.vue
// module id = 355
// module chunks = 0